<!-- Command palette overlay — solo se renderiza cuando service.isOpen() -->
<ng-container *ngIf="service.isOpen()">
  <div class="cp-overlay"
       @overlayFade
       (click)="onBackdropClick()"
       role="dialog"
       aria-modal="true"
       [attr.aria-label]="'commandPalette.titulo' | translate">
    <div class="cp-sheet"
         @sheetIn
         (click)="$event.stopPropagation()">

      <!-- Input row -->
      <div class="cp-input-row">
        <span class="cp-input-icon" aria-hidden="true">
          <app-icon name="search" [size]="18"></app-icon>
        </span>
        <input #paletteInput
               type="text"
               class="cp-input"
               [placeholder]="'commandPalette.placeholder' | translate"
               [value]="service.query()"
               (input)="onInput($any($event.target).value)"
               autocomplete="off"
               autocorrect="off"
               autocapitalize="off"
               spellcheck="false"
               aria-autocomplete="list" />
        <kbd class="cp-esc">ESC</kbd>
      </div>

      <!-- Results -->
      <div class="cp-results" #paletteResults role="listbox">

        <!-- Recientes -->
        <ng-container *ngIf="service.results().recents.length > 0">
          <div class="cp-group-label">
            <app-icon name="circledot" [size]="11"></app-icon>
            {{ 'commandPalette.grupos.recientes' | translate }}
          </div>
          <button *ngFor="let r of service.results().recents; let i = index; trackBy: trackId"
                  type="button"
                  class="cp-result"
                  role="option"
                  [class.is-selected]="globalIdx('recents', i) === selectedIdx()"
                  [attr.aria-selected]="globalIdx('recents', i) === selectedIdx()"
                  (mouseenter)="onHoverItem(globalIdx('recents', i))"
                  (click)="onClickItem(r)">
            <span class="cp-result-icon">
              <app-icon [name]="r.icon || 'detailslayout'" [size]="16"></app-icon>
            </span>
            <span class="cp-result-label">{{ r.label }}</span>
            <span class="cp-result-meta">{{ 'commandPalette.metas.reciente' | translate }}</span>
          </button>
        </ng-container>

        <!-- Páginas -->
        <ng-container *ngIf="service.results().pages.length > 0">
          <div class="cp-group-label">
            <app-icon name="folder" [size]="11"></app-icon>
            {{ 'commandPalette.grupos.paginas' | translate }}
          </div>
          <button *ngFor="let p of service.results().pages; let i = index; trackBy: trackId"
                  type="button"
                  class="cp-result"
                  role="option"
                  [class.is-selected]="globalIdx('pages', i) === selectedIdx()"
                  [attr.aria-selected]="globalIdx('pages', i) === selectedIdx()"
                  (mouseenter)="onHoverItem(globalIdx('pages', i))"
                  (click)="onClickItem(p)">
            <span class="cp-result-icon">
              <app-icon [name]="p.icon || 'detailslayout'" [size]="16"></app-icon>
            </span>
            <span class="cp-result-label">{{ p.label }}</span>
            <span class="cp-result-meta" *ngIf="p.hint">{{ p.hint }}</span>
          </button>
        </ng-container>

        <!-- Acciones -->
        <ng-container *ngIf="service.results().actions.length > 0">
          <div class="cp-group-label">
            <app-icon name="sparkles" [size]="11"></app-icon>
            {{ 'commandPalette.grupos.acciones' | translate }}
          </div>
          <button *ngFor="let a of service.results().actions; let i = index; trackBy: trackId"
                  type="button"
                  class="cp-result"
                  role="option"
                  [class.is-selected]="globalIdx('actions', i) === selectedIdx()"
                  [attr.aria-selected]="globalIdx('actions', i) === selectedIdx()"
                  (mouseenter)="onHoverItem(globalIdx('actions', i))"
                  (click)="onClickItem(a)">
            <span class="cp-result-icon">
              <app-icon [name]="a.icon || 'sparkles'" [size]="16"></app-icon>
            </span>
            <span class="cp-result-label">{{ a.label }}</span>
            <span class="cp-result-meta" *ngIf="a.hint">{{ a.hint }}</span>
          </button>
        </ng-container>

        <!-- Empty state -->
        <div class="cp-empty" *ngIf="totalResults() === 0">
          <app-icon name="search" [size]="32"></app-icon>
          <p class="cp-empty-title">
            {{ 'commandPalette.sinResultados' | translate }}
          </p>
          <p class="cp-empty-hint" *ngIf="service.query()">
            "{{ service.query() }}"
          </p>
        </div>
      </div>

      <!-- Footer hints -->
      <div class="cp-footer">
        <span class="cp-hint">
          <kbd>↑</kbd><kbd>↓</kbd>
          {{ 'commandPalette.hints.navegar' | translate }}
        </span>
        <span class="cp-hint">
          <kbd>↵</kbd>
          {{ 'commandPalette.hints.seleccionar' | translate }}
        </span>
        <span class="cp-hint">
          <kbd>ESC</kbd>
          {{ 'commandPalette.hints.cerrar' | translate }}
        </span>
        <span class="cp-hint cp-hint-shortcut">
          <kbd>⌘</kbd><kbd>K</kbd>
          {{ 'commandPalette.hints.atajo' | translate }}
        </span>
      </div>
    </div>
  </div>
</ng-container>
